<template>
  <div v-if="hasPermission(permissions.propertyHoldEdit)">
    <content-header>{{ $t('editPropertyHold') }}</content-header>
    <v-content>
      <b-card>
        <b-card-body>
          <form class="forms-sample" @submit.prevent="onSubmit">
            <text-input id="name" :name="$t('name')" :validate="$v" :required="true" :is-loading="isLoading"/>
            <text-input id="phone" :name="$t('phone')" :validate="$v" :is-loading="isLoading"/>
            <select-input
                label="name"
                id="payType"
                :name="$t('payType')"
                :api-link="payTypes"
                :required="true"
                @itemSelected="e => form.payType = e"
            />
            <text-input v-if="form.payType === 2" id="bankName" :name="$t('bankName')" :validate="$v" :required="true" :is-loading="isLoading"/>
            <text-input v-if="form.payType === 2" id="bankSlipNumber" :name="$t('bankSlipNumber')" :validate="$v" :required="true" :is-loading="isLoading"/>
            <date-time-input v-if="form.payType === 2" id="bankSlipDate" :name="$t('bankSlipDate')" :validate="$v" :required="true" :is-loading="isLoading" />
            <text-input v-if="form.payType === 2" id="bankSlipNote" :name="$t('bankSlipNote')" :validate="$v" :required="true" :is-loading="isLoading"/>
            <number-input id="holdPayment" :name="$t('holdPayment')" :show-locale-string="true" :validate="$v" :required="true" :is-loading="isLoading" />
           
            <div class="form-group row">
              <label class="col-sm-2 col-form-label text-right">{{ $t('remain2') }}</label>
              <div class="col-sm-10">
                <p class="lead pt-1">{{ remain && remain.toLocaleString() }}</p>
              </div>
            </div>
            <date-time-input id="date" :name="$t('date')" :validate="$v" :required="true" :is-loading="isLoading" />
            <date-time-input id="deadline" :name="$t('deadline')" default-value="" :validate="$v" :is-loading="isLoading" />
            <text-area-input id="note" :name="$t('note')" :validate="$v" :is-loading="isLoading" />
            <submit-input :name="$t('create')" :disabled="isLoading" />
            <is-loading v-if="isLoading" />
          </form>
        </b-card-body>
      </b-card>
    </v-content>
  </div>
</template>

<script>
import Content from "@/components/Content";
import ContentHeader from "@/components/ContentHeader";
import { required } from 'vuelidate/lib/validators'
import IsLoading from "@/components/IsLoading";
import {PropertyHold} from "@/models/PropertyHold";
import SubmitInput from "@/components/Inputs/SubmitInput";
import DateTimeInput from "@/components/Inputs/DateTimeInput";
import SelectInput from "@/components/Inputs/SelectInput";
import NumberInput from "@/components/Inputs/NumberInput";
import TextAreaInput from "@/components/Inputs/TextAreaInput";
import TextInput from "@/components/Inputs/TextInput";
import PayType from "@/enums/PayType";
import {permissions} from "@/plugins/constants";

export default {
  name: "PropertyHoldEdit",
  components: {TextInput, TextAreaInput, NumberInput, SelectInput, DateTimeInput, SubmitInput, ContentHeader, 'v-content': Content, IsLoading},
  data() {
    return {
      form: this.$helpers.convertArrayToObject(new PropertyHold().fillAbles),
      isLoading: false,
      selectedItem: {},
      payTypes: PayType,
      property: {},
      remain: 0,
      permissions: permissions
    }
  },
  watch: {
    "form.holdPayment"(newVal) {
      this.remain = this.property && this.property.finalPrice && (this.property.finalPrice - newVal);
    }
  },
  mounted() {
    this.loadOneData();
  },
  validations: {
    form: {
      propertyId: {required},
      name: {},
      isCustomer: {},
      customerId: {},
      payType: {},
      bankName: {},
      bankSlipNumber: {},
      bankSlipDate: {},
      bankSlipNote: {},
      holdPayment: {required},
      phone: {},
      date: {required},
      deadline: {},
      note: {}
    }
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$pending || this.$v.$error) return false;
      this.isLoading = true;
      this.$store.dispatch('propertyHolds/UPDATE', {id: this.$route.params.id, form: this.form}).then(() => {
        this.$v.$reset();
        this.$router.push({name: "propertyHolds"});
      }).catch(() => this.isLoading = false);
    },
    loadOneData() {
      this.isLoading = true;
      this.$store.dispatch('propertyHolds/GET_ONE', this.$route.params.id).then((response) => {
        this.form       = response.data;
        this.form.payType = response.data.payType === 'BankSlip' || response.data.payType === 2 ? 2 : 1;
        this.isLoading  = false;
      }).catch(() => this.isLoading = false);
    },
    propertySelected(e) {
      this.property = e;
      this.form.propertyId = e.id;
    },
  }
}
</script>
